/**
 * 縦長が正面の端末のランドスケープ時のアングル
 */
const landscapeAngle = 90;

/**
 * ObserDevicever
 */
export default class Device {
    /**
     * コンストラクタ
     */
    constructor() {
        /** @property {number} orientation 向き */
        this.orientation = window.orientation;

        /** @property {number | null} width 表示領域の横幅 */
        this.width = null;

        /** @property {number | null} height 表示領域の縦幅 */
        this.height = null;
    }

    /**
     * 表示領域のサイズを取得する
     */
    getScreenSize() {
        return new Promise(promise => this.awaitPortrait(promise));
    }

    /**
     * ポートレートとみなすまで待ってから表示領域のサイズを返す
     */
    awaitPortrait(resolve) {
        const { innerWidth: width, innerHeight: height, orientation } = window;

        if (typeof orientation === 'undefined' || height > width) {
            resolve({ width, height });
            return;
        }

        setTimeout(() => {
            if (this.width || this.height) {
                resolve({ width: this.width, height: this.height });
                return;
            }
            this.awaitPortrait(resolve);
        }, 5);
    }

    /**
     * 表示領域のサイズを初期化する
     */
    initScreenSize() {
        if (this.width || this.height) {
            return Promise.resolve();
        }

        return this.setScreenSize();
    }

    /**
     * 表示領域のサイズをセットする
     */
    setScreenSize() {
        return this.getScreenSize().then((size) => {
            this.width = size.width;
            this.height = size.height;
        });
    }

    /**
     * 表示領域のサイズを取得する
     */
    getWindowInner() {
        const [width, height] = [window.innerWidth, window.innerHeight]
            .sort((a, b) => (this.isLandscapePrimaryDevice() ? a + b : a - b));

        return {
            width,
            height,
        };
    }

    /**
     * 画面の向きが横か
     */
    isLandscape(context = this) {
        if (typeof context.orientation === 'undefined') {
            return false;
        }

        const orientation = Math.abs(context.orientation);
        return this.isLandscapePrimaryDevice() ? orientation !== landscapeAngle : orientation === landscapeAngle;
    }

    /**
     * ポートレートとみなすまで待ってから表示領域のサイズを返す
     */
    awaitOrientationChange(resolve) {
        const { orientation } = window;

        if (typeof orientation === 'undefined') {
            resolve();
            return;
        }

        if (this.orientation !== orientation) {
            this.orientation = orientation;
            resolve();
            return;
        }

        setTimeout(() => {
            this.awaitOrientationChange(resolve);
        }, 5);
    }

    /**
     * 端末が横長が正面かどうか
     */
    isLandscapePrimaryDevice() {
        const orientationType = (window.screen.orientation || {}).type;

        const orientationPattern = `${orientationType}:${window.orientation}`;
        switch (orientationPattern) {
            case 'portrait-primary:-90':
            case 'portrait-secondary:90':
            case 'landscape-primary:0':
            case 'landscape-secondary:180':
                return true;
            default:
                return false;
        }
    }
}
